import { render, staticRenderFns } from "./LevelDot.vue?vue&type=template&id=be9f889a&scoped=true"
import script from "./LevelDot.vue?vue&type=script&lang=ts"
export * from "./LevelDot.vue?vue&type=script&lang=ts"
import style0 from "./LevelDot.vue?vue&type=style&index=0&id=be9f889a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9f889a",
  null
  
)

export default component.exports